import { render, staticRenderFns } from "./DirectSaleProductForm.vue?vue&type=template&id=178f9c7f&scoped=true"
import script from "./DirectSaleProductForm.vue?vue&type=script&lang=js"
export * from "./DirectSaleProductForm.vue?vue&type=script&lang=js"
import style0 from "./DirectSaleProductForm.vue?vue&type=style&index=0&id=178f9c7f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "178f9c7f",
  null
  
)

export default component.exports